module.exports = __webpack_public_path__ + "img/Porto Apartment - 78 of 85.4c712746.jpeg";